// extracted by mini-css-extract-plugin
export default {"col":"index_col_Ab5IS","adbox":"index_adbox_hq9-m","box650":"index_box650_HsJfY"};